// src/components/FeatureSection.js
import React from "react";
import styles from "../styles/FeatureSection.module.css";

function FeatureSection({ title, description, images, isEven }) {
  return (
    <div className={`${styles.container} ${isEven ? styles.even : styles.odd}`}>
      <div className={styles.imageGallery}>
        {images.map((imgSrc, index) => (
          <img
            key={index}
            src={imgSrc}
            alt={`${title} ${index + 1}`}
            className={styles.featureImage}
          />
        ))}
      </div>
      <div className={styles.textWrapper}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  );
}

export default FeatureSection;
